import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TestSeriesService } from '../../service/test-series.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import { commonService } from "../../service/common.service";
import { Title,Meta } from "@angular/platform-browser";
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'app-packagelist',
  templateUrl: './packagelist.component.html',
  styleUrls: ['./packagelist.component.css'],
  providers: [TestSeriesService,Title,Meta],
  animations: [
    trigger('scrollAnimation', [
      state('show', style({
        opacity: 1,
        transform: "translateX(0)"
      })),
      state('hide', style({
        opacity: 0,
        transform: "translateX(-100%)"
      })),
      transition('show => hide', animate('700ms ease-out')),
      transition('hide => show', animate('700ms ease-in'))
    ])
  ]
})
export class PackagelistComponent implements OnInit {
  @Input() myPackageSeriesId: any;
  @Input() myPackage: any;

  typetxt: any = '';
  packageList: any = [];
  totalrow: any = 0;
  notfound: any;
  isPostLoad = true;
  msg: any;
  isRemaningForum: any;
  postId: any = 0;
  ngload: any;
  userData: any;
  filter: any;
  noMoreResults: any;
  isError = false;
  siteUrl = this.global.websiteUrl;
  paperList: any = [];
  streambox: any = [{ id: '' }];
  isMyPackage = false;
  streamText: any = '';
  loggedinUserId: any = 0;

  userDatalogincheck: any;

  //Stype = '';

  constructor(private testseriesservice: TestSeriesService, private router: Router, private route: ActivatedRoute, private global: Globals, private commonService: commonService,private titleService: Title,private meta: Meta) {

    this.commonService.profile.subscribe((data: any) => {

      if (data) {
        this.userDatalogincheck = data;
      } else {
        this.userDatalogincheck = {};
      }

    });

  }

  ngOnInit() {
    this.titleService.setTitle("Buy Test Series for GATE, ESE, SSC, PSU Exam - Student Portal");
    this.meta.updateTag({ name: 'description', content: 'Buy Online Test Series which are meticulously designed for Competitive Exams like UPSC IES/ESE, GATE Exam, PSU Entrance Exam and other State Level Competitive exams.' });
    this.meta.updateTag({ name: 'keywords', content: 'Online Test Series, Competitive Exams, UPSC IES, GATE 2020, ESE Exam, PSU, Engineering Service Exam, Entrance Exam, CE, ME, EE, EC, CS, IT, IN, PI, GS, General Studies' });

    this.loggedinUserId = (this.commonService.user) ? this.commonService.user.id : 0;
    this.route.params.subscribe((params: Params) => {
      if (params['id']) {
        this.isPostLoad = true;
        this.postId = parseInt(params['id']);

        if (isNaN(this.postId)) {
          this.postId = 0;
        }
        // console.log('ddddddddddddddddddddd');
        if (this.postId > 0) {
          this.typetxt = this.postId;
          this.packageList = [];
          let filter = {};
          filter = { limit: 10 };
          this.getPackageList(filter);
          this.ngload = true;
        }
      }
    });


    if (this.myPackage && Object.keys(this.myPackage).length != 0) {
      //console.log('22222222222222');
      this.isMyPackage = true;
      this.userData = this.myPackage;
      this.packageList = [];
      this.isPostLoad = true;
      let filter = {};
      this.getStreamList('');
      filter = { limit: 10 };
      if (this.userData && this.userData.id) {
        filter['userId'] = this.userData.id;
      }
      this.getMyPackageList(filter);
    } else {  //console.log('111111111');

      let filter = {};
      this.isMyPackage = false;
      this.getStreamList('');
      filter = { limit: 10 };
      if (this.userData && this.userData.id) {
        filter['userId'] = this.userData.id;
      }
      this.packageList = [];
      if (this.postId == 0) this.getPackageList(filter);
    }

    this.ngload = true;


  }


  getPackageList(obj) {
    obj['orderby'] = "id";
    obj['offset'] = this.packageList.length ? this.packageList.length : 0;
    obj['studentId'] = (this.userDatalogincheck) ? this.userDatalogincheck.id : 0;
    obj['streamId'] = this.typetxt;
    this.getstreamText();
    this.testseriesservice.getmainstslist(obj).subscribe((data: any) => {

      if (data.error == 0) {
        if (data.results.rows.length > 0) {
          Array.prototype.push.apply(this.packageList, data.results.rows);
          // console.log('gg',this.packageList);
          this.isPostLoad = false;
        } else {
          this.isRemaningForum = false;
          this.isPostLoad = false;
          this.noMoreResults = true;
          this.packageList = [];
          // console.log('cccccc',this.noMoreResults);
        }

      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.isPostLoad = false;
      this.msg = "internal server error!";
    });
  }


  getStreamList(streamId) { //streamlist
    this.testseriesservice.getteststreams(streamId).subscribe((data: any) => {
      if (data.error == 0) {
        // console.log('stream',data);
        this.streambox = data.results;
        this.getstreamText();
      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    },
      (error: HttpErrorResponse) => {
        this.isError = true;
        this.msg = "internal server error!";
      });

  }

  filterform(searchtxt) {
    this.ngload = true;
    var Stype = searchtxt.value.Stype.trim();
    this.typetxt = Stype;
    let filter = {};
    filter = { limit: 1000 };
    this.packageList = [];
    this.getPackageList(filter);
  }

  loadmorePackage() {
    //console.log('loadmoreForum');
    this.getPackageList({ limit: 10, isnewList: true });
  }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    var scrollPosition = $(window).scrollTop() + $(window).height();
    //var pageheight =  $(document).height()
    var pageheight = $(document).height() - $('#footer-section').outerHeight();
    if (scrollPosition >= pageheight && this.isRemaningForum == true && this.postId == 0 && this.isPostLoad != true) {
      this.isPostLoad = true;
      this.loadmorePackage();
    }

  }

  paperUrl(tpid) {
    return '../../packagedetail/' + btoa(tpid);
  }

  mytestpaperUrl(tpid) {
    return '../../mypackagedetail/' + btoa(tpid);
  }

  testseriesImageUrl(imagename) {
    imagename = (imagename != '') ? imagename : 'ts_demo.jpg';
    return this.global.testseriesImageUrl + imagename;
  }

  datediff(date) {
    return this.commonService.datediff(date);
  }

  streamUrl() {
    if (this.postId) return "../../";
    else return "../";
  }

  checklogin(plist) {
    let pid = plist.id;
    if (Object.keys(this.userDatalogincheck).length == 0) {
      this.needLogin();
      return false;
    }
    if(plist.paymentMode)
      window.open(plist.externalURL, '_blank');
    else
      this.router.navigateByUrl('/student-form-pre-payment/' + pid);
  }

  needLogin() {
    this.commonService.setLoginBox(true);
  }

  getExpireDate(lastDate) {
    var date = new Date();
    var ld = new Date(lastDate);
    if (date > ld) return true;
    else return false;
  }

  getstreamText() {
    if (this.streambox) {
      for (let st of this.streambox) {
        if (st.id == this.postId) {
          this.streamText = (st.detail) ? st.detail : '';
          continue;
        }
      }
    }

  }

  purchasedAlready(pid) {

  }

  getMyPackageList(obj) {

    obj['orderby'] = "id";
    obj['offset'] = this.packageList.length ? this.packageList.length : 0;
    //obj['userid']="id";  
    obj['streamId'] = this.typetxt;
    obj['status'] = 'completed';
    this.getstreamText();
    this.testseriesservice.getstudentpurchaselist(obj).subscribe((data: any) => {
      let finaldata = [];
      if (data.error == 0) {
        if (data.results.rows.length > 0) {
          for (let mypackagedata of data.results.rows) {
            if (mypackagedata.orderItem) {
              finaldata.push(mypackagedata.orderItem.testSery);
            }
          }
          Array.prototype.push.apply(this.packageList, finaldata);
          // console.log('gg',this.packageList);
          this.isPostLoad = false;
        } else {
          this.isRemaningForum = false;
          this.isPostLoad = false;
          this.noMoreResults = true;
          this.packageList = [];
          //console.log('cccccc',this.noMoreResults);
        }

      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.isPostLoad = false;
      this.msg = "internal server error!";
    });
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/packagelist/packagelist.component.ts